import { AppConfigContext } from '@infl-ts/util-app-config';
import { usePreviousProp } from '@infl-ts/util-hooks';
import { usePageEventsTracker } from '@infl-ts/util-page-events-tracker';
import { useChallengePlayer } from '@infl-ts/util-use-challenge-player';
import { Box, Dialog, Typography } from '@mui/material';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ChallengeCard } from '../../challenge-card';
import { challengePages, onboardingCategories } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var OnboardingChallenge = function OnboardingChallenge(_ref) {
  var profile = _ref.profile,
      challenge = _ref.challenge,
      canClose = _ref.canClose,
      onClose = _ref.onClose,
      isPreview = _ref.isPreview;

  var _useChallengePlayer = useChallengePlayer(),
      open = _useChallengePlayer.challengePlayerState.open,
      manuallyOpenChallengePlayer = _useChallengePlayer.manuallyOpenChallengePlayer;

  var _usePageEventsTracker = usePageEventsTracker(),
      startActivity = _usePageEventsTracker.startActivity,
      stopActivity = _usePageEventsTracker.stopActivity,
      trackClick = _usePageEventsTracker.trackClick;

  var prevIsPlayerOpen = usePreviousProp(open);

  var _useContext = useContext(AppConfigContext),
      programName = _useContext.programName;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  useEffect(function () {
    startActivity(onboardingCategories.challenge, challengePages.welcome);
  }, []);
  useEffect(function () {
    if (onClose && prevIsPlayerOpen !== open && !open) onClose();
  }, [prevIsPlayerOpen, open, onClose]);
  return /*#__PURE__*/_jsxs(Dialog, {
    open: true,
    fullScreen: true,
    sx: {
      zIndex: function zIndex(t) {
        return t.zIndex.belowDrawer;
      }
    },
    PaperProps: {
      sx: {
        pt: 12,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }
    },
    "data-element": "Dialog",
    "data-component": "OnboardingChallenge",
    "data-source-file": "onboarding-challenge.tsx",
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "h2",
      sx: {
        mb: 2,
        textAlign: 'center'
      },
      "data-element": "Typography",
      "data-component": "OnboardingChallenge",
      "data-source-file": "onboarding-challenge.tsx",
      children: t('Welcome to {{programName}}, {{profileName}}!', {
        programName: programName,
        profileName: profile.name
      })
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "h3",
      sx: {
        mb: 3,
        textAlign: 'center'
      },
      "data-element": "Typography",
      "data-source-file": "onboarding-challenge.tsx",
      children: t('Click on the Challenge card to get started:')
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        width: 230
      },
      onClick: function onClick() {
        trackClick('Onboarding Challenge Card', onboardingCategories.challenge, challengePages.welcome);
        stopActivity(onboardingCategories.challenge, challengePages.welcome);
      },
      "data-element": "Box",
      "data-source-file": "onboarding-challenge.tsx",
      children: /*#__PURE__*/_jsx(ChallengeCard, {
        challenge: challenge,
        hideActions: true,
        onClick: function onClick() {
          return manuallyOpenChallengePlayer({
            uuid: challenge.id,
            onboarding: true,
            canClose: canClose,
            isPreview: isPreview
          });
        },
        "data-element": "ChallengeCard",
        "data-source-file": "onboarding-challenge.tsx"
      })
    })]
  });
};